import {
  EventBusAdapter,
  EventBusAdapterFactory,
} from './adapters/eventBusAdapter';
import { EventBus } from './eventBus';

export interface EventBusInitOptions {
  enableLogging?: boolean;
  adapters: EventBusAdapterFactory[];
}

export class EventBusManager {
  private static instance: EventBusManager | null = null;
  private readonly eventBus: EventBus;
  private adapters: EventBusAdapter[] = [];

  private constructor(options: EventBusInitOptions) {
    const { enableLogging = false, adapters } = options;

    this.eventBus = new EventBus({ enableLogging });

    this.adapters = adapters.map((adapterFactory) =>
      adapterFactory.create(this.eventBus),
    );
    this.adapters.forEach((adapter) => adapter.start());

    window.addEventListener('beforeunload', () => {
      this.stop();
    });

    if (enableLogging) {
      /* eslint-disable no-console */
      console.log(
        '[EventBus] Initialized with',
        this.adapters.length,
        'adapter(s)',
      );
    }
  }

  static getInstance(): EventBusManager {
    if (!EventBusManager.instance) {
      throw new Error(
        '[EventBus] Not initialized. Call initEventBus() in bootstrap.tsx first',
      );
    }
    return EventBusManager.instance;
  }

  static initialize(options: EventBusInitOptions): EventBusManager {
    if (EventBusManager.instance) {
      /* eslint-disable no-console */
      console.warn(
        '[EventBus] Already initialized, reinitializing with new options',
      );
      EventBusManager.instance.stop();
    }
    EventBusManager.instance = new EventBusManager(options);
    return EventBusManager.instance;
  }

  getEventBus(): EventBus {
    return this.eventBus;
  }

  stop(): void {
    this.adapters.forEach((adapter) => adapter.stop());
    this.adapters = [];
  }
}
